import * as Yup from 'yup';

export const hostSchema = Yup.object({
    name: Yup.string().required('El nombre del host es requerido'),
    avatar: Yup.string().required('La URL del avatar es requerida'),
    profileLink: Yup.string().url('La URL del perfil debe ser válida').optional(),
})